export default (value) => value !== '29.02.'
